import { encryptDataWithIV, decryptDataWithIV } from "../app-utils";

export const SERVER_URL = process.env.REACT_APP_BASE_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
export const GOOGLE_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${GOOGLE_REDIRECT_URI}&response_type=token&scope=email profile`;
export const FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID;
export const FACEBOOK_SECRET = process.env.REACT_APP_FACEBOOK_SECRET;

export const getUser = () => {
  const json_data: any = localStorage.getItem("aa_data");
  return !!json_data ? JSON.parse(decryptDataWithIV(json_data)) : null;
};

export const storeUser = (data: any) => {
  const json_data = JSON.stringify(data);
  localStorage.setItem("aa_data", encryptDataWithIV(json_data));
};

export const removeUser = () => {
  localStorage.removeItem("aa_data");
};
